export function getProcessedImageUrl(imagePath) {
  if (!imagePath) return null;

  const apiUrl = process.env.VUE_APP_API_URL;
  const fileName = imagePath.split("/").pop();

  return `${apiUrl}/file_uploads/${fileName}`;
}

export default {
  getProcessedImageUrl,
};
